<template>
    <main class="main-content">
        <img src="/images/svg/404.svg">
        <span class="nfd_text">{{$t("notFound")}}</span>
        <div class="nfd_description">{{$t("notFoundDesc")}}</div>
        <router-link to="/" class="nfd_btn">{{$t("toMain")}}</router-link>
    </main>
</template>
<script>

</script>
<style scoped>
.main-content{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #289853;
    font-weight: bold;
    gap: 15px;
    background-image: url("/public/images/backgrounds/404.png");
    background-repeat: no-repeat;
    background-position: 50% 25%;
}
.nfd_text{
    margin: 20px 0 10px 0;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 32px;
    line-height: 42px;
    text-align: center;
    letter-spacing: -0.03em;
    color: #0F0F0F;
}
.nfd_description{
    width: 360px;
    height: 80px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: #808784;
}
.nfd_btn{
    background: linear-gradient(45deg, #10934F 0%, #83C555 100%);
    box-shadow: 0px 8px 40px rgba(18, 148, 79, 0.3);
    border-radius: 12px;
    padding: 12px 24px;
    color: #fff;
}
.nfd_btn:hover{
    background: linear-gradient(45deg, #13B05F 0%, #94DE60 100%);
    transition: all .2s ease-in;
}
@media (max-width: 1200px) { 
    .main-content img{
        max-width: 250%;
        margin-top: 120px;
    }
}
</style>